<template>
  <v-app v-resize="onResize" class="overflow-hidden newDashBackground">
    <div class="drawer-container">
      <div v-if="showControlFloatingCard" class="control-card">
        <div class="d-flex align-center">
          <div class="pa-2 control-logo mr-4">
            <v-img
              width="35"
              contain
              class=""
              src="@/assets/appslogos/icons/icon-control.png"
            />
          </div>

          <div>
            <p class="control-title">Conecta Control</p>
            <a class="control-link" @click="openControlApp">
              <span>{{ $t("common.access") }}</span></a
            >
          </div>
        </div>
      </div>

      <Sidebar
        v-if="!editingTemplate && !userIsOnSelfCheckout"
        @executeRequestActivation="requestActivation"
      />
    </div>

    <!-- NOTIFICATION SIDEBAR -->
    <NotificationsSidebar v-if="currentUser" :color="primaryColor" />

    <Navbar
      @snackbarPurchaseInterest="requestActivation"
      @openSupport="openSupport"
    />

    <v-main :width="bodyWidth" class="newDashBackground overflow-hidden pb-0">
      <div
        v-if="isSimulation"
        class="d-flex justify-center align-center mt-2"
        style="height: 42px; background-color: #8165d1"
        color="#8165D1"
      >
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <v-avatar
            left
            size="24"
            style="margin-bottom: -5px; border: 1px solid #ffffff"
          >
            <img :src="resellerPhoto" :alt="currentUser.name" />
          </v-avatar>
          <v-avatar left size="24" class="avatar-content">
            <img :src="userPhoto" alt="reseller photo" />
          </v-avatar>
        </div>
        <span
          class="white--text poppins-600 ml-3"
          v-html="
            $t('newDashboard.simulation', { userName: currentUser.first_name })
          "
        >
        </span>
        <v-btn
          width="74"
          height="18"
          outlined
          @click="endSimulationMode"
          class="white--text d-flex justify-center align-center ml-3 poppins-600"
          style="font-weight: 600 !important"
          data-cy="end-simulation-button"
        >
          {{ $t("common.back") }}
        </v-btn>
      </div>

      <v-container
        fluid
        class="ma-0 pa-0 mt-5 background"
        v-if="missingScopesSuite.length"
      >
        <div class="ma-0 newDashBackground">
          <v-row>
            <v-col cols="12" class="px-9">
              <ScopeAlert class="my-3 mx-0" />
            </v-col>
          </v-row>
        </div>
      </v-container>
      <router-view />
    </v-main>
    <!-- GLOBAL SNACKBAR -->
    <CsSnackbar
      data-testid="snackbar-global"
      :show="isShowingSnackbar"
      :snackbar-messages="snackbarMessages"
      :message-key="snackbar.is_key ? snackbarMessageKey : ''"
      :message="snackbarMessage"
      :timeout="snackbarTimeout"
      :notShowCloseButton="snackbarShowCloseButton"
      :closeButtonText="$t('common.close')"
      :color="snackbarColor"
      @close="resetSnackbarInfo"
      style="z-index: 999"
    />

    <Guide v-if="showFloatingGuide" />

    <PriceChangeNotice />

    <SimpleDialog
      :show="isVisibleModalSupport"
      :title="$t('supportDialog.title')"
      :showCancel="false"
      :readOnly="true"
      @close="closeSupportModal"
      width="500"
    >
      <template v-slot:body>
        <p
          class="mt-2 text-title-1"
          v-html="$t('supportDialog.message', { name: resellerCompanyName })"
        ></p>
      </template>
    </SimpleDialog>

    <v-btn
      v-show="chatLoading"
      color="primary"
      elevation="2"
      fab
      loading
      class="fab-button-chat"
    ></v-btn>
  </v-app>
</template>

<script>
import PriceChangeNotice from "@/components/base/PriceChangeNotice.vue";
import Guide from "@/components/home/Guide.vue";
import ScopeAlert from "@/components/home/ScopeAlert.vue";
import Navbar from "@/components/main/newDashboard/Navbar.vue";
import Sidebar from "@/components/main/newDashboard/Sidebar.vue";
import NotificationsSidebar from "@/components/main/notifications/NotificationsSidebar.vue";
import {
  dateIsToday,
  getResellerPhotoFromToken,
  goToControl,
} from "@/helpers/services/utils";
import { snackbarMessages } from "@/helpers/variables/snackbarMessages";
import { getAnalytics, logEvent } from "firebase/analytics";
import { mapActions, mapGetters, mapMutations } from "vuex";

import {
  setPathDefaultHubSpotTrack,
  setTrackingPathsHubspot,
} from "@/helpers/hubspot";

export default {
  name: "NewDashboard",
  components: {
    Sidebar,
    Navbar,
    NotificationsSidebar,
    Guide,
    PriceChangeNotice,
    ScopeAlert,
  },
  data: () => ({
    showSnackbar: false,
    snackbarType: "success",
    snackbarText: "",
    showBlackFriday: false,
    bodyWidth: 0,

    // temporary warining
    defaultPhoto: require("@/assets/user-default.png"),
    snackbarMessages,
  }),

  computed: {
    ...mapGetters([
      "currentRoute",
      "hasBillingPermission",
      "primaryColor",
      "company",
      "currentUser",
      "isSimulation",
      "token",
      "snackbar",
      "isShowingSnackbar",
      "snackbarTimeout",
      "snackbarMessage",
      "snackbarColor",
      "snackbarShowCloseButton",
      "snackbarMessageKey",
      "feedbackButtonClick",
      "hasEndedTrial",
      "isSmallClient",
      "hasProcessRunning",
      "emailTransferInProgressPath",
      "showControlFloatingCard",
      "showFloatingGuide",
      "allVacationTemplates",
      "chatLoading",
      "missingScopesSuite",
      "isVisibleModalSupport",
      "resellerCompanyName",
    ]),

    userIsOnSelfCheckout() {
      return (
        this.currentRoute === "BillingUpgradePlan" && this.hasBillingPermission
      );
    },

    editingTemplate() {
      return this.$route.name === "TemplateEdit";
    },

    feedbacksButtons() {
      return document.getElementsByClassName("feedback-button");
    },

    mainDomain() {
      return this.company.main_domain;
    },

    isHomePage() {
      return this.$route.name == "Home";
    },

    hasMigrationRunning() {
      return this.hasProcessRunning || this.emailTransferInProgressPath;
    },

    isCompanyCreatedToday() {
      return dateIsToday(this.company.created_at);
    },
    userPhoto() {
      return this.currentUser.photo || this.defaultPhoto;
    },
    resellerPhoto() {
      const token = this.token.split(" ")[1];
      return getResellerPhotoFromToken(token) || this.defaultPhoto;
    },
  },

  watch: {
    showBlackFriday() {
      if (!this.showBlackFriday) {
        this.showBlackFriday = false;
        localStorage.setItem("showBlackFriday", "false");
      }
    },

    "$route.path": async function () {
      if (
        !["ResellerNewPlan", "ResellerClientInfo"].includes(this.$route.name)
      ) {
        localStorage.removeItem("selectedResellerClient", "");
      }
      if (!this.isSimulation) {
        setTrackingPathsHubspot(this.$route.fullPath);
      }
    },

    feedbacksButtons(newValue, oldValue) {
      if (newValue.lenght !== oldValue.lenght) {
        this.removeFeedback();
        this.setFeedback();
      }
    },

    feedbackButtonClick() {
      this.showCollectorDialog();
    },
    hasMigrationRunning(value) {
      if (value) {
        window.addEventListener("beforeunload", this.tasksProcessesHandler);
        window.addEventListener("beforeunload", this.leaveDriveProcessRoom);
        window.addEventListener("unload", this.leaveDriveProcessRoom);
      } else {
        window.removeEventListener("beforeunload", this.tasksProcessesHandler);
        window.removeEventListener("beforeunload", this.leaveDriveProcessRoom);
        window.removeEventListener("unload", this.leaveDriveProcessRoom);
      }
    },
  },

  methods: {
    ...mapMutations([
      "setSidebarView",
      "setLoading",
      "resetSnackbarInfo",
      "setLocale",
      "closeControlCard",
      "setFloatingGuide",
      "setOpenModalSupport",
    ]),

    openControlApp() {
      goToControl();
      this.closeControlCard();
    },

    tasksProcessesHandler(event) {
      event.preventDefault();
      event.returnValue = "";
    },

    ...mapActions([
      "getUsers",
      "purchaseInterest",
      "getScopes",
      "checkBillingPermission",
      "getPlans",
      "syncUos",
      "getUos",
      "leaveDriveProcessRoom",
      "getSyncUsersStatus",
      "getVacationTemplates",
      "endSimulationMode",
    ]),

    dateIsToday,

    openSupport() {
      if (this.$route.name != "ContactUs")
        this.$router.push({ name: "ContactUs" });
    },

    loadJiraFeedbackIntegration() {
      var s = document.createElement("script");
      s.src =
        "https://conectanuvem.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/1jmxwi/b/8/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=pt-BR&collectorId=12a150ca";
      document.body.appendChild(s);
    },

    setFeedback() {
      const _this = this;
      window.ATL_JQ_PAGE_PROPS = {
        triggerFunction: function (showCollectorDialog) {
          _this.feedbacksButtons.forEach((element) => {
            element.addEventListener("click", (e) => {
              e.preventDefault();
              showCollectorDialog();
            });
          });
          _this.showCollectorDialog = showCollectorDialog;
        },
      };
    },

    showCollectorDialog() {},

    removeFeedback() {
      const _this = this;
      window.ATL_JQ_PAGE_PROPS = {
        triggerFunction: function () {
          _this.feedbacksButtons.forEach((element) => {
            element.removeEventListener("click", false);
          });
        },
      };
    },

    onResize() {
      this.bodyWidth = this.sidebarMini
        ? window.innerWidth - 230
        : window.innerWidth - 300;
    },

    updateContract() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/contract`;
      const auth = {
        headers: {
          Authorization: this.token,
        },
      };
      this.$axios.put(url, {}, auth);
    },

    requestActivation(product) {
      this.checkBillingPermission()
        .then(() => {
          const analytics = getAnalytics();

          logEvent(analytics, "go_to_self_checkout", {
            click: "trial_bar",
            main_domain: this.mainDomain,
            email: this.currentUser.email,
            description:
              "Clicou no botão 'Contratar plano' do menu de trial na barra superior (navbar)",
          });

          this.$router.push("/billing/add-plan");
        })
        .catch(() => {
          this.snackbarType = "warning";
          this.snackbarText =
            "Acesso negado, para contratar um plano contate o seu administrador!";
          this.showSnackbar = true;
        })
        .finally(() => {
          // Envio de evento RD informando sobre interesse de aquisição de plano
          this.purchaseInterest(product)
            .then(() => {
              // this.textSuccess = "Solicitação realizada com sucesso!";
              // this.snackbarSuccess = true;
            })
            .catch(() => {
              this.textFailure = "Erro ao realizar a solicitação!";
              this.snackbarFailure = true;
            });
        });
    },

    saveLocale(lang) {
      this.$i18n.locale = lang;
      this.$vuetify.lang.current = lang == "pt-br" ? "pt" : lang;
      localStorage.setItem("lang", lang);
      this.setLocale(lang);
    },

    closeSupportModal() {
      this.setOpenModalSupport(false);
    },
  },

  async beforeMount() {
    this.setLoading(true);
    this.saveLocale(this.company.language);

    if (this.$vuetify.breakpoint.mobile) {
      this.setSidebarView(false);
    }
    this.getScopes();

    if (!this.company.uos) this.syncUos();

    if (this.isCompanyCreatedToday) this.getSyncUsersStatus();

    await Promise.all([
      this.loadJiraFeedbackIntegration(),
      this.getUsers(),
      this.getPlans(),
      this.getUos(),
    ]).then(() => {
      if (
        !this.isSimulation &&
        !this.company.contract &&
        this.currentUser.is_google_admin
      ) {
        this.updateContract();
      }
      this.setLoading(false);
    });

    if (!this.allVacationTemplates.length) {
      this.getVacationTemplates();
    }

    if (this.isSimulation) {
      return;
    }

    setPathDefaultHubSpotTrack();

    if (JSON.parse(localStorage.getItem("showFloatingGuide")) === false) {
      this.setFloatingGuide(false);
    } else {
      this.setFloatingGuide(true);
    }
  },

  mounted() {
    this.setFeedback();
  },

  beforeDestroy() {
    this.removeFeedback();
    window.removeEventListener("beforeunload", this.leaveDriveProcessRoom);
    window.removeEventListener("unload", this.leaveDriveProcessRoom);
    window.removeEventListener("beforeunload", this.tasksProcessesHandler);
  },
};
</script>

<style lang="scss" scoped>
.newDashBackground {
  background-color: #f4f3f3;
}

.drawer-container {
  position: relative;
}

.control-card {
  position: fixed;
  top: 10px;
  left: 295px;

  background-color: white;

  border-radius: 12px;
  border: 1px solid #d9d9d9;
  display: inline-block;

  width: 250px;
  padding: 0.4rem;
  z-index: 9999;
}

.control-logo {
  border-radius: 16px;
  background-color: #ebf5fc;
}

.control-title {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 1rem;
  margin-bottom: 0;
  color: #404040;
  line-height: 17px;
}

.control-link {
  text-decoration: underline;
  text-decoration-color: #3498db;
}

.control-link span {
  color: #3498db;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
}

.poppins-600 {
  font-family: Poppins !important;
  font-size: 12px !important;
  line-height: 18px !important;
}
.avatar-content {
  border: 1px solid #ffffff;
  border-radius: 50%;
  margin-left: -7px;
  margin-top: -10px;
}
</style>
